import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.css']
})
export class AdminUsersComponent implements OnInit {

  users$;

  constructor(private   userService: UserService) { 
    this.users$ = this.userService.getAll();
    //console.log(this.users$);
  }

  ngOnInit() {
  }

  parseDate(createdTimestamp) { 
    if(createdTimestamp) return createdTimestamp;
    else return "1571011200000"; // Default init date
  }
  
}
